import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config as SanitizeConfig } from 'sanitize-text/sanitizers/SanitizeConfiguration';
export const sanitizeHtml = htmlString => {
  return sanitize(htmlString, SanitizeConfig.HTML);
};